/**
 * @author HungNS
 */
import Vue from "vue";
import moment from "moment";
import IConstants from "@/common/constants/IConstants.js";
import FHConvert from "@/common/converter/fhconvert.js";
import {find} from 'lodash';
import i18n from "@/lang/i18n";

const formatDate = Vue.filter("formatDate", function (input, inputPattern, outputPattern) {
    if (input == null) {
        return "";
    }
    var _date = moment(input, inputPattern).format(outputPattern);
    return _date.toUpperCase();
});

const textMessageKind = Vue.filter("textMessageKind", function (messageKind) {
    if (messageKind == IConstants.MESSAGE_KIND.NOTIFICATION) {
        return "お知らせ";
    } else if (messageKind == IConstants.MESSAGE_KIND.IMPORTANT) {
        return "重要";
    } else if (messageKind == IConstants.MESSAGE_KIND.CAMPAIGN) {
        return "キャンペーン";
    } else if (messageKind == IConstants.MESSAGE_KIND.SEMINAR) {
        return "セミナー";
    } else if (messageKind == IConstants.MESSAGE_KIND.MAINTENANCE) {
        return "メンテナンス";
    } else if (messageKind == IConstants.MESSAGE_KIND.OTHER) {
        return "その他";
    }
});

const textServiceTypePopup = Vue.filter("textServiceTypePopup", function (serviceType) {
    if (serviceType == IConstants.SERVICE_TYPE.SOCIAL) {
        return "ST";
    } else if (serviceType == IConstants.SERVICE_TYPE.AMS) {
        return "All";
    } else if (serviceType == IConstants.SERVICE_TYPE.BO) {
        return "OP";
    } else if (serviceType == IConstants.SERVICE_TYPE.NTD_FX) {
        return "FX";
    } else if (serviceType == IConstants.SERVICE_TYPE.CRYPTO_FX) {
        return "コイン";
    }
});

const numberFormat = Vue.filter("numberFormat", function (val, format) {
    if (isNaN(val) || val === null || val === undefined) return "";
    return Number.parseFloat(val).toFixed(format);
});

const formatAmount = Vue.filter('formatAmount', function (val, maxLength) {
    if (val != null && val != "") {
        val = val.toString();
        val = FHConvert.ftoh(val);
        val = val.replace(/[^0-9]/g, '');
        val = parseFloat(val) + '';
        if (isNaN(val)) {
            return '';
        }
        if (maxLength)
            val = val.substr(0, maxLength);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    else {
        return val;
    }
});

const getByProperty = Vue.filter("getByProperty", function (key, value, collection) {
    const result = find(collection, item => (item[key] === value));
    return result;
})

const getByPropertyName = Vue.filter('getByPropertyName', function (propertyName, propertyValue, collection) {
    var i = 0, len = collection.length;
    for (; i < len; i++) {
        if (collection[i][propertyName] == propertyValue) {
            return collection[i];
        }
    }
    return null;
});

const namingCurrency = Vue.filter("namingCurrency", function (input) {
    input = input.toUpperCase();
    if (input == 'JPY') {
        return '円';
    }
    return input;
});

const numberFormats = Vue.filter("moneyAmountFormat", function (value) {
    return Number(value).toLocaleString(i18n.locale);
});

const moneyFormats = Vue.filter("moneyFormat", function (value) {
    return Number(Number(value).toFixed(0)).toLocaleString(i18n.locale);
});


export default {
    formatDate,
    textMessageKind,
    textServiceTypePopup,
    numberFormat,
    formatAmount,
    getByProperty,
    getByPropertyName,
    namingCurrency,
    numberFormats,
    moneyFormats
};
